import React, { useEffect, useState } from "react";
import { FaSearch } from "react-icons/fa";
import { Modal, Button, Table, Col, Row, Container, InputGroup, Form } from "react-bootstrap";

import "react-datepicker/dist/react-datepicker.css";
import { useDispatch, useSelector } from "react-redux";


import {
  handleGetTenantData,
  handleGetTenantsData,
  handleGetTenantCropsData,
  handleGetTenantSchedualersData,
} from "../store/actions/tenantsActions";
import {
  handleCreateSchedualer,
  
  handleDeleteSchedualer,
  handleDeleteTask,
  handleEditSchedualer,
  handleUpdateSchedualer
} from "../store/actions/scheduallerActions";

// Components
import Loader from "../assets/images/loader.gif";
import { ICONS, IMAGES } from "../constants/constants";
import AddTaskModal from "./AddTaskModel";
import AddSchedualerModal from "../components/Modals/AddSchedualerModal";
import EditTaskModal from "./EditTaskModal";
import SchedualerDetailsModal from "../components/Modals/SchedualerDetailsModal";
import CloneRenameSchedualerModal from "../components/Modals/CloneRenameSchedualerModal";

const ManageSchedualers = () => {
  const dispatch = useDispatch();
  const currentYear = new Date().getFullYear();

  const [loading, setLoading] = useState(false);
  const [isCreatingSchedualer, setIsCreatingSchedualer] = useState(false);
  const [isDeletingSchedualer, setIsDeletingSchedualer] = useState(false);

  const { regionList } = useSelector((state) => state.crop);
  const {  tenantData, tenantSchedualersData, tenantCropsData, isLoading } = useSelector((state) => state.tenants);
  const { user } = useSelector((state) => state.user);

  const userrole = user?.role;
  const tenantId = userrole === "superadmin" ? user?.tenant?.id : null;

  useEffect(() => {
    if (tenantId) {
      dispatch(handleGetTenantData(tenantId));
      dispatch(handleGetTenantCropsData(tenantId));
      dispatch(handleGetTenantSchedualersData(tenantId));
    }
  }, [dispatch, tenantId]);

  const productList = tenantData?.data?.tenant?.products;

  const schedualersList = tenantSchedualersData || [];

  

  const [showScheduallerModal, setShowScheduallerModal] = useState(false);
  const [showSchedualler, setShowSchedualler] = useState(false);
  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [editTaskData, setEditTaskData] = useState(null);
  const [deletedTask, setDeletedTask] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [schedualerToDelete, setSchedualerToDelete] = useState(null);
const [showSchedualerDeleteModal, setShowSchedualerDeleteModal] = useState(false);
const [searchTerm, setSearchTerm] = useState("");
const [showCloneConfirmModal, setShowCloneConfirmModal] = useState(false);


const [showCloneRenameModal, setShowCloneRenameModal] = useState(false);
const [cloneRenameMode, setCloneRenameMode] = useState("clone");
const [targetSchedualer, setTargetSchedualer] = useState(null);

 const [selectedCropId, setSelectedCropId] = useState("");


const handleCloneClick = (schedualer) => {
  if (!schedualer?.crop?.id) {
    console.warn("Missing crop.id in schedualer", schedualer);
    return;
  }
  setTargetSchedualer(schedualer);
  setSelectedCropId(schedualer?.crop?.id || "");
  setCloneRenameMode("clone");
  setShowCloneConfirmModal(true); // Show confirmation modal first
};




const handleRenameClick = (schedualer) => {
  setTargetSchedualer(schedualer);
  setCloneRenameMode("rename");
  setShowCloneRenameModal(true);
};

const handleCloneRenameSubmit = async (newName, regionId) => {
  if (!targetSchedualer) return;
  if (cloneRenameMode === "clone") {
    const payload = {
      cropId: targetSchedualer.crop?.id,
      regionId, // ✅ use selected region from modal
      SchedualerName: newName,
      tasks: targetSchedualer.tasks || [],
    };
    console.log("Cloning schedualer payload:", payload);
    const result = await handleCreateSchedualer(payload, dispatch);
if(result) {
      setShowCloneRenameModal(false);
      console.log("Schedualer cloned successfully:", result);
      dispatch(handleGetTenantSchedualersData(tenantId));


    }
  } else {
    // const updated = {
    //   schedualerName: newName,
    // };
    console.log("Renaming schedualer to:", newName);
    const payload = {
      // cropId: targetSchedualer.crop?.id,
      // regionId, // ✅ use selected region from modal
      schedualerName: newName,
      // tasks: targetSchedualer.tasks || [],
    };
    console.log("Renaming schedualer payload:", payload);
    await handleUpdateSchedualer(targetSchedualer.id, payload, dispatch);
  }

  setShowCloneRenameModal(false);
  setTargetSchedualer(null);
  dispatch(handleGetTenantSchedualersData(tenantId));
  // Reload to reflect changes
};





 const [selectedCropScheduallerData, setSelectedCropScheduallerData] = useState(null);

  const handleAddTaskToNewSchedualer = (schedualer) => {
  
    // if (!schedualer || !schedualer.crop) {
    //   console.warn("Invalid schedualer data:", schedualer);
    //   return;
    // }
  setSelectedCropScheduallerData({
    cropName: schedualer?.crop?.crop_name || "N/A",
    schedualer,
  });
  setShowAddModal(true);
};


 
  const [cropScheduallerData, setCropScheduallerData] = useState({
  schedualer_name: "", // ✅ fixed key name
  cropId: "",
  cropName: "",
  regionId: "",
  tasks: [
    {
      task_category: "",
      task_description: "",
      assigned_date: "",
      due_date: "",
      products: [],
    },
  ],
});


  const [errors, setErrors] = useState({});

  const handleScheduallerModalShow = (cropId, cropName, regions = []) => {
    setCropScheduallerData({ cropId: "", cropName: "", regionId: "", regions, tasks: [{ task_category: "", task_description: "", assigned_date: "", due_date: "", products: [] }] });
    setShowScheduallerModal(true);
  };

 const handleScheduallerShow = (cropName, schedualer) => {
  setSelectedCropScheduallerData({ cropName, schedualer });
  setShowDetailsModal(true);
};


  const handleSaveEditedTask = async (updatedTask) => {
    if (!selectedCropScheduallerData?.schedualer?.id || !updatedTask?.task_id) return;
    const formData = { task_id: updatedTask.task_id, updatedTask };
    setLoading(true);
    if (loading) return <div className="loaderOverlay"><img src={Loader} alt="Loader" /></div>;

    await handleEditSchedualer(selectedCropScheduallerData.schedualer.id, formData, dispatch);
    setShowEditModal(false);
    setLoading(false);
    dispatch(handleGetTenantSchedualersData(tenantId));


  };

  // const handleSaveAddTask = (newTask) => {
  //   if (!selectedCropScheduallerData) return;
  //   setSelectedCropScheduallerData(prev => ({
  //     ...prev,
  //     schedualer: {
  //       ...prev.schedualer,
  //       tasks: [...prev.schedualer.tasks, newTask],
  //     },
  //   }));
  //   setShowAddModal(false);
  // };

  // const handleDeleteTaskClick = (task) => {
  //   setDeletedTask(task);
  //   setShowModal(true);
  // };

  const handleConfirmDelete = async () => {
    if (!deletedTask) return;
    if (loading) return;
    setLoading(true);
    await dispatch(handleDeleteTask(selectedCropScheduallerData?.schedualer?.id, deletedTask.task_id));
    setShowModal(false);
    setDeletedTask(null);
    setLoading(false);
  };


  const handleConfirmSchedualerDelete = async () => {
    if (!schedualerToDelete) return;
    if (isDeletingSchedualer) return;
    setIsDeletingSchedualer(true);
    await dispatch(handleDeleteSchedualer(schedualerToDelete.id));
    setShowSchedualerDeleteModal(false);
    setSchedualerToDelete(null);
    setIsDeletingSchedualer(false);
    dispatch(handleGetTenantSchedualersData(tenantId));
 // ✅ reload the page after successful deletion
  };

  const addSchedualer = async () => {
    if (isCreatingSchedualer) return;
  
    const { cropId, regionId, schedualer_name } = cropScheduallerData;
  
    // Validation
    const newErrors = {};
    if (!schedualer_name?.trim())
      newErrors.schedualer_name = "Scheduler name is required.";
    if (!cropId) newErrors.cropId = "Crop is required.";
    if (!regionId) newErrors.regionId = "Region is required.";
  
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }
  
    setIsCreatingSchedualer(true);
  
    try {
      const payload = {
        cropId,
        regionId,
        SchedualerName: schedualer_name.trim(),
      };
  
      const result = await handleCreateSchedualer(payload, dispatch);
  
      if (result?.schedualer) {
        const newSchedualer = result.schedualer;
  
        // ✅ Reset form completely
        setCropScheduallerData({
          schedualer_name: "",
          cropId: "",
          cropName: "",
          regionId: "",
          tasks: [],
        });
  
        setErrors({});
        setShowScheduallerModal(false);
  
        // ✅ Move to next step
        handleAddTaskToNewSchedualer(newSchedualer);
      }
    } catch (error) {
      console.error("Scheduler creation failed:", error);
    } finally {
      setIsCreatingSchedualer(false); // ✅ Always clear loading
    }
  };
  


const renderSchedualerList = () => {
  let schedualers = schedualersList?.data?.schedualers || [];
  // console.log("renderSchedualerList - schedualers:", schedualers);
   // Filter by search term
  if (searchTerm.trim()) {
    const lowerTerm = searchTerm.toLowerCase();
    schedualers = schedualers.filter(
      (s) =>
        s?.schedualerName?.toLowerCase().includes(lowerTerm) ||
      s?.crop?.crop_name?.toLowerCase().includes(lowerTerm) ||
        s?.region?.region?.toLowerCase().includes(lowerTerm)
    );
  }

  // Filter only those that have at least one task
   if (!schedualers.length) {
    return <tr><td colSpan="6">No schedulers available.</td></tr>;
  }

  return schedualers.map((schedualer, index) => {
    const sortedTasks = [...(schedualer.tasks || [])].sort(
      (a, b) => new Date(a.assigned_date) - new Date(b.assigned_date)
    );

    const startDate = sortedTasks[0]?.assigned_date || "N/A";
    const endDate = sortedTasks[sortedTasks.length - 1]?.due_date || "N/A";

    return (
      <tr key={schedualer.id}>
        <td>{schedualer?.schedualerName || "N/A"}</td>
         <td>{schedualer.crop?.crop_name || "N/A"}</td>
        <td>
          <img
            src={schedualer.crop?.crop_image || IMAGES.productImage}
            alt="crop"
            style={{ width: 25, height: 25, objectFit: "cover" }}
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = IMAGES.productImage;
            }}
          />
        </td>
        <td>{schedualer.region?.region || "N/A"}</td>
        <td>{schedualer.tasks?.length || 0}</td>
        

        <td>{startDate}</td>
        <td>{endDate}</td>
        <td>
          <Row>
            <Col md={2}>
              <Button
                variant="link"
                className="p-0 border-0 bg-transparent"
                onClick={() =>
                  handleScheduallerShow(schedualer.crop?.crop_name || "N/A", schedualer)
                }
              >
                <img src={ICONS.viewIcon} className="faPlusIcon" alt="view" />
              </Button>
            </Col>
           <Col md={2}>
  <Button
    variant="link"
    className="p-0 border-0 bg-transparent"
    onClick={() => handleAddTaskToNewSchedualer(schedualer)} // ✅ new handler
  >
    <img src={ICONS.plusIcon} className="faPlusIcon" alt="add-task" />
  </Button>
</Col>

            <Col md={2}>
  <Button
    variant="link"
    className="p-0 border-0 bg-transparent"
    onClick={() => handleCloneClick(schedualer)}
  >
    <img src={ICONS.duplicateIcon} className="faPlusIcon" alt="Clone" />
  </Button>
</Col>
<Col md={2}>
  <Button
    variant="link"
    className="p-0 border-0 bg-transparent"
    onClick={() => handleRenameClick(schedualer)}
  >
    <img src={ICONS.editIcon} className="faPlusIcon" alt="Rename" />
  </Button>
</Col>

            <Col md={2}>
              <Button
                variant="link"
                className="p-0 border-0 bg-transparent"
                onClick={() => {
  setSchedualerToDelete(schedualer);
  setShowSchedualerDeleteModal(true);
}}

              >
                <img src={ICONS.deleteIcon} className="faPlusIcon" alt="delete" />
              </Button>
            </Col>
          </Row>
        </td>
      </tr>
    );
  });
};



  if (isLoading) return <div className="loaderOverlay"><img src={Loader} alt="Loader" /></div>;

  return (
    <Container>
      <Modal show={showCloneConfirmModal} onHide={() => setShowCloneConfirmModal(false)}>
  <Modal.Header closeButton>
    <Modal.Title>Confirm Clone</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    Are you sure you want to duplicate the schedualer <b>{targetSchedualer?.schedualerName}</b>?<br />
    You can rename it in the next step.
  </Modal.Body>
  <Modal.Footer>
    <Button className="reject-button" onClick={() => setShowCloneConfirmModal(false)}>
      Cancel
    </Button>
    <Button className="button" onClick={() => {
      setShowCloneConfirmModal(false); // Close confirmation
      setShowCloneRenameModal(true);  // Open clone modal
    }}>
      Yes
    </Button>
  </Modal.Footer>
</Modal>

   <CloneRenameSchedualerModal
  show={showCloneRenameModal}
  handleClose={() => setShowCloneRenameModal(false)}
  mode={cloneRenameMode}
  onSubmit={handleCloneRenameSubmit}
  initialName={targetSchedualer?.schedualerName}
  schedualerCrop={selectedCropId} // ✅ Now this is reliable
/>


      <Modal show={showSchedualerDeleteModal} onHide={() => setShowSchedualerDeleteModal(false)}>
  <Modal.Header closeButton>
    <Modal.Title>Confirm Delete</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    Are you sure you want to delete the schedualer <b>{schedualerToDelete?.schedualerName}</b>?
    This will also delete all its associated tasks.
  </Modal.Body>
  <Modal.Footer>
    <Button className="reject-button" onClick={() => setShowSchedualerDeleteModal(false)} disabled={isDeletingSchedualer}>
      Cancel
    </Button>
    <Button className="button" onClick={handleConfirmSchedualerDelete} disabled={isDeletingSchedualer}>
      {isDeletingSchedualer ? "Deleting..." : "Yes"}
    </Button>
  </Modal.Footer>
</Modal>

      <Row className="component-container mb-2">
        <Col md={12}>
          <Row>
            <Col md={4}><h4>Schedulers</h4></Col>
   <Col md={5} className="text-end">
  <InputGroup className="w-100 position-relative">
    <Form.Control
      type="text"
      placeholder="Search by Name, Crop or Region"
      value={searchTerm}
      onChange={(e) => setSearchTerm(e.target.value)}
      className="search-input rounded-input pe-5"
    />

    {/* 🔍 Search icon */}
    <InputGroup.Text className="search-icon-wrapper">
      <FaSearch className="search-icon" 
      />
    </InputGroup.Text>

    {/* ❌ Clear button (always visible if there's text) */}
    {searchTerm && (
     <button
  type="button"
  className="btn btn-link p-0 position-absolute end-0 top-50 translate-middle-y"
  onClick={() => setSearchTerm("")}
  style={{
    border: "none",
    background: "transparent",
    fontSize: "1.2rem",
    color: "#888",
    zIndex: 5,          // ensures it stays above everything
    marginRight: "3rem",
    boxShadow: "none",  // remove shadow
    textDecoration: "none", // removes underline from btn-link
  }}
>
  ✕
</button>

    )}
  </InputGroup>
</Col>


            <Col md={3} className="text-end">
            
              <Button className="button" onClick={() => handleScheduallerModalShow(null, null, regionList)} disabled={isCreatingSchedualer}>
                <img src={ICONS.addPlusIcon} className="faPlusIcon" alt="Add" /> Add New Scheduler
              </Button>
            </Col>
          </Row>
          <div style={{ overflowX: 'auto' }}>
            <Table striped bordered hover className="mt-3">
              <thead>
  <tr>
    <th>Scheduler Name</th>
    <th>Crop Name</th>
    <th>Image</th>
    <th>Region</th>
    <th>No of Tasks</th>
    <th>Start Date</th>
    <th>End Date</th>
    <th>Action</th>
  </tr>
</thead>

              <tbody>{renderSchedualerList()}</tbody>
            </Table>
          </div>
        </Col>
      </Row>

      <AddSchedualerModal
        show={showScheduallerModal}
        handleClose={() => setShowScheduallerModal(false)}
        cropScheduallerData={cropScheduallerData}
        setCropScheduallerData={setCropScheduallerData}
        productList={productList}
        errors={errors}
        currentYear={currentYear}
        handleCreateScheduler={addSchedualer}
        isCreatingSchedualer={isCreatingSchedualer}
      />

      <AddTaskModal
  show={showAddModal}
  handleClose={() => setShowAddModal(false)}
  productList={productList}
  selectedCropScheduallerData={selectedCropScheduallerData}

/>


      <EditTaskModal
        show={showEditModal}
        handleClose={() => setShowEditModal(false)}
        task={editTaskData}
        schedualerId={selectedCropScheduallerData?.schedualer?.id}
        productList={productList}
        onSave={handleSaveEditedTask}
      />

<SchedualerDetailsModal
  show={showDetailsModal}
  handleClose={() => setShowDetailsModal(false)}
  schedualerData={selectedCropScheduallerData}
  setSchedualerData={setSelectedCropScheduallerData}
  productList={productList}
/>

      <Modal show={showSchedualler} onHide={() => setShowSchedualler(false)} fullscreen>
        <Modal.Header closeButton><Modal.Title>Crop Scheduler - {selectedCropScheduallerData?.cropName}</Modal.Title></Modal.Header>
        <Modal.Body>
          {selectedCropScheduallerData?.schedualer?.tasks?.length > 0 ? (
            <>
              <Row className="mb-3">
                <Col md={6}>Tasks</Col>
                <Col md={6} className="text-end">
                  <Button className="button no-hover" onClick={() => { setEditTaskData(null); setShowAddModal(true); }}>
                    <img src={ICONS.addPlusIcon} className="faPlusIcon" alt="Add" /> Add New Task
                  </Button>
                </Col>
              </Row>
              <Table striped bordered hover className="mt-3">
  <thead>
    <tr>
      <th>Crop Name</th>
      <th>Crop Image</th>
      <th>Region</th>
      <th>Task Start Date</th>
      <th>Task End Date</th>
      <th>Action</th>
    </tr>
  </thead>
  <tbody>{renderSchedualerList()}</tbody>
</Table>

            </>
          ) : <p>No tasks available for this scheduler.</p>}
        </Modal.Body>
      </Modal>

      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton><Modal.Title>Confirm Delete</Modal.Title></Modal.Header>
        <Modal.Body>Are you sure you want to delete task <b>{deletedTask?.task_description || ''}</b>?</Modal.Body>
        <Modal.Footer>
          <Button className="reject-button" variant="secondary" onClick={() => setShowModal(false)}>Cancel</Button>
          <Button className="button" style={{ backgroundColor: "red" }} onClick={handleConfirmDelete}>Yes</Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
};

export default ManageSchedualers;